// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ik-6";
export var emphasizeQuantity = "_ik-3";
export var flatBottomCorners = "_ik-5";
export var productImage = "_ik-0";
export var quantityContainer = "_ik-2";
export var tooltip = "_ik-1";
export var wrapAndEllipsesOverflow = "_ik-4";